class FormFieldType {
    Id: number;
    FieldType: string;

    constructor() {
        this.Id = 0;
        this.FieldType = "";
    }
}

export default FormFieldType;